(() => {
  if (customElements.get('ct-october-offer')) return;
  customElements.define('ct-october-offer', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const deadline = Date.parse(this.dataset.deadline);
      const tick = () => {
        const left = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        this.hidden = !Number.isFinite(deadline) || left <= 0;
        if (this.hidden) { clearInterval(this.timer); return; }
        const values = { days: Math.floor(left / 86400), hours: Math.floor(left % 86400 / 3600), minutes: Math.floor(left % 3600 / 60), seconds: left % 60 };
        Object.entries(values).forEach(([key, value]) => {
          this.querySelectorAll('[data-clock-' + key + ']').forEach(node => {
            node.textContent = String(value).padStart(2, '0');
          });
        });
      };
      tick();
      if (!this.hidden) this.timer = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
})();

